'use client';

import {motion} from 'framer-motion';
import useTopStyle from '../../utils/useTopStyle';
import BookBtn from '../buttons/BookBtn/BookBtn';
import heroVariants from '../../animation/heroVariants';
import spanVariants from '../../animation/spanVariants';

import ServicesHeroSvg1 from '../../animation/svg-anim/ServicesHeroSvg1';
import ServicesHeroSvg2 from '../../animation/svg-anim/ServicesHeroSvg2';
import ServicesHeroSvg1Mobile from '../../animation/svg-anim/ServicesHeroSvg1Mobile';
import ServicesHeroSvg2Mobile from '../../animation/svg-anim/ServicesHeroSvg2Mobile';

const Nbsp = () => '\u00A0';

const ServicesHero = () => {
  const ref = useTopStyle(72);

  return (
    <motion.section
      className='services-hero'
      ref={ref}
      initial={'hidden'}
      animate={'visible'}
      transition={{
        duration: 0.7,
        delay: 0.5,
        ease: 'easeInOut'
      }}
      variants={heroVariants}
    >
      <div className='container'>
        <div className='bg-line'>
          <ServicesHeroSvg1 />
          <ServicesHeroSvg2 />
        </div>
        <div className='bg-line-mobile'>
          <ServicesHeroSvg1Mobile />
          <ServicesHeroSvg2Mobile />
        </div>
        <div className='logo'></div>
        <div className='data'></div>
        <h2 className='title'>
          Partner managed security and IT services.
          <Nbsp />
          <motion.span
            className='highlight'
            initial={'hidden'}
            animate={'visible'}
            transition={{
              duration: 0.8,
              delay: 0.8,
              ease: 'easeInOut'
            }}
            variants={spanVariants}
          >
            Powered by Cylerian.
          </motion.span>
        </h2>
        <BookBtn text='Get help today' />
      </div>
    </motion.section>
  );
};

export default ServicesHero;

